<template>
    <div>
        <b-jumbotron>
            <p><a :href="pdfLink">Yardımcı Dökümanı İndirmek İçin Tıklayın</a></p>
            <p>Yardımcı Video:</p>
            <div style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/a70f29e84ce646b48a87aa831d7e48c7" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>        </b-jumbotron>
    </div>
</template>

<script>
    export default {
        name: 'Yardim',
        computed: {
            pdfLink() {
                return "https://latinize.kizilay.org.tr/KızılayYardımcıDöküman.pdf";
            }
        }
    }
</script>
